/**
 * DARMHA logo animation — the brand-transition morph (DHARMA BUMS -> DARMHA).
 *
 * Ported from the Claude Design composition "logo-morph-site". The artwork
 * (letterform paths, tagline) and the authored timeline (scene cues, easings,
 * positions) are carried over verbatim; the React/Babel player it shipped in
 * is not. The final frame is geometrically identical to the static logo SVG
 * (verified against the live asset: 449/449 path points, max deviation
 * 0.036px in the 775x144 box), so the hand-off back to the <img> is seamless.
 *
 * Progressive enhancement over the static header logo:
 *   - the static <img> always renders and paints first (LCP unchanged)
 *   - the overlay only plays when every gate passes; every failure path,
 *     including mid-play exceptions and resizes, restores the static logo
 *   - plays per browser session are capped by the header section setting
 *     (data-darmha-anim-plays on the logo link), counted in sessionStorage
 *
 * The header lives outside the PJAX-swapped #content, so soft navigations
 * never re-run this — it can only play on genuine full page loads.
 */
(function () {
  'use strict';

  var LETTERS = {"OLD":{"D":{"d":"M54.51,51.42h9.72c6.32,0,12.36-3.88,12.36-14.85,0-10.01-3.46-16.38-14.29-16.38h-7.77v31.24h-.03ZM43.63,11.03h21.37c12.84,0,22.48,8.05,22.48,24.49,0,14.37-7.37,25.06-22.48,25.06h-21.37V11v.03Z","x":43.6},"H":{"d":"M95.05,11.03L105.96,11.03L105.96,30.05L126.03,30.05L126.03,11.03L136.91,11.03L136.91,60.6L126.03,60.6L126.03,39.2L105.96,39.2L105.96,60.6L95.05,60.6L95.05,11.03Z","x":95},"A1":{"d":"M159,41.44h12.84l-6.24-18.2h-.14l-6.46,18.2ZM160.04,11.03h11.17l18.54,49.55h-11.31l-3.74-11.03h-18.54l-3.88,11.03h-11.03l18.82-49.55h-.03Z","x":141.2},"R":{"d":"M204.94,33.45h11.93c4.85,0,7.48-2.07,7.48-7.09s-2.64-6.89-7.48-6.89h-11.93v13.97ZM194.06,11.03h26.73c8.87,0,14.51,6.18,14.51,13.66,0,5.84-2.35,10.2-7.85,12.44v.14c5.36,1.39,6.86,6.6,7.23,11.59.2,3.12.14,8.96,2.07,11.74h-10.89c-1.33-3.12-1.19-7.91-1.73-11.88-.77-5.22-2.78-7.48-8.25-7.48h-10.89v19.36h-10.89V11.03h-.06Z","x":194},"M1":{"d":"M244.18,11.03L259.51,11.03L271.11,45.13L271.25,45.13L282.22,11.03L297.55,11.03L297.55,60.6L287.35,60.6L287.35,25.46L287.21,25.46L275.07,60.6L266.66,60.6L254.52,25.82L254.38,25.82L254.38,60.6L244.18,60.6L244.18,11.03Z","x":244.2},"A2":{"d":"M319.63,41.44h12.84l-6.26-18.2h-.14l-6.46,18.2h.03ZM320.68,11.03h11.17l18.54,49.55h-11.31l-3.74-11.03h-18.54l-3.88,11.03h-11.03l18.82-49.55h-.03Z","x":301.9},"B":{"d":"M357.34,57.97h16.81c8.76,0,14.23-3.88,14.23-11.25,0-8.48-7.71-10.54-14.23-10.54h-16.81v21.8ZM357.34,33.53h16.81c8.28,0,12.56-4.17,12.56-10.2,0-7.14-5.98-9.64-12.56-9.64h-16.81v19.84ZM354.27,11.06h19.84c11.79,0,15.62,6.46,15.62,12.84,0,5.36-3.88,9.86-9.64,10.54l.14.14c1.33-.2,11.17,2.15,11.17,12.16,0,9.01-6.94,13.89-17.29,13.89h-19.84V11.06Z","x":354.3},"U":{"d":"M401.07,11.03v29.71c0,5.98,1.25,18.4,15.56,18.4,12.13,0,16.24-7.14,16.24-18.4V11.03h3.06v29.71c0,11.79-4.42,21.03-19.3,21.03-17.63,0-18.6-14.43-18.6-21.03V11.03h3.06-.03Z","x":398},"M2":{"d":"M444.67,11.03L449.04,11.03L468.4,57.2L468.54,57.2L487.7,11.03L492.09,11.03L492.09,60.6L489.03,60.6L489.03,14.77L488.89,14.77L470.01,60.6L466.95,60.6L447.85,14.77L447.73,14.77L447.73,60.6L444.67,60.6L444.67,11.03Z","x":444.7},"S":{"d":"M533.17,25.2c-.34-8.48-6.72-12.7-15.9-12.7-5.64,0-13.61,2.35-13.61,10.54s8.48,9.3,16.87,11.03c8.48,1.73,16.95,3.88,16.95,13.75s-9.86,13.95-17.43,13.95c-11.59,0-21.03-4.79-20.89-17.57h3.06c-.62,10.83,8.05,14.94,17.83,14.94,5.98,0,14.37-2.69,14.37-11.31s-8.48-9.86-16.92-11.59c-8.42-1.73-16.87-3.74-16.87-13.18s8.82-13.18,16.67-13.18c10.35,0,18.45,4.45,18.94,15.34h-3.06Z","x":499}},"NEW":{"D":{"d":"M147.1,83.16c7.86,0,13.76-2.23,17.69-6.7s5.9-11.03,5.9-19.7-2.28-15.23-6.83-19.7c-4.47-4.47-10.85-6.7-19.16-6.7h-26v52.8h28.41ZM107.43,26.34c0-.98-.22-1.74-.67-2.28-.45-.63-1.29-.94-2.55-.94v-1.61h41.54c5.54,0,10.5.89,14.87,2.68,4.47,1.7,8.22,4.11,11.26,7.24,3.13,3.13,5.54,6.88,7.24,11.26,1.7,4.29,2.55,8.98,2.55,14.07s-.72,9.83-2.14,14.2c-1.43,4.29-3.57,8-6.43,11.12-2.77,3.13-6.25,5.58-10.45,7.37-4.11,1.7-8.89,2.55-14.34,2.55h-44.09v-1.61c1.25,0,2.1-.27,2.55-.8.45-.63.67-1.43.67-2.41V26.34Z","x":104.2},"A1":{"d":"M247.69,64.4l-15.14-31.62-13.94,31.62h29.08ZM209.76,83.96c-.36.8-.76,1.7-1.21,2.68-.45.98-.67,1.74-.67,2.28,0,.98.76,1.47,2.28,1.47v1.61h-16.48v-1.61c.54,0,.98-.04,1.34-.13.45-.09.85-.36,1.21-.8.36-.45.76-1.07,1.21-1.88.45-.89,1.03-2.05,1.74-3.48l24.25-54.14c.71-1.52,1.25-2.64,1.61-3.35.36-.8.54-1.43.54-1.88,0-1.07-.8-1.61-2.41-1.61v-1.61h19.56v1.61c-1.43,0-2.14.54-2.14,1.61,0,.54.22,1.25.67,2.14.45.8,1.03,1.97,1.74,3.48l25.73,53.33c.8,1.61,1.43,2.86,1.88,3.75s.85,1.56,1.21,2.01c.45.45.89.71,1.34.8.45.09,1.07.13,1.88.13v1.61h-18.63v-1.61c1.07,0,1.79-.13,2.14-.4.36-.36.54-.85.54-1.47,0-.45-.13-.89-.4-1.34-.18-.54-.62-1.61-1.34-3.22l-5.09-10.72h-37.92l-4.56,10.72Z","x":193.7},"R":{"d":"M336.8,52.34c5.45,0,9.29-1.03,11.52-3.08,2.23-2.05,3.35-4.87,3.35-8.44,0-1.79-.22-3.31-.67-4.56-.45-1.25-1.25-2.28-2.41-3.08-1.16-.89-2.77-1.52-4.82-1.88-1.96-.45-4.51-.67-7.64-.67h-28.68v21.71h29.35ZM307.45,87.18c0,.98.22,1.79.67,2.41.45.54,1.3.8,2.55.8v1.61h-17.69v-1.61c1.25,0,2.1-.27,2.55-.8.45-.63.67-1.43.67-2.41V26.34c0-.98-.22-1.74-.67-2.28-.45-.63-1.3-.94-2.55-.94v-1.61h44.89c8.84,0,15.19,1.7,19.03,5.09,3.84,3.31,5.76,8.13,5.76,14.47,0,5.63-1.47,10.09-4.42,13.4-2.95,3.31-7.77,5.4-14.47,6.3l16.88,26.13c.98,1.43,1.74,2.37,2.28,2.81.62.45,1.61.67,2.95.67v1.61h-19.3v-1.61c1.16,0,1.88-.09,2.14-.27.36-.18.54-.49.54-.94,0-.54-.22-1.03-.67-1.47l-16.48-26.26h-24.66v25.73Z","x":293},"M":{"d":"M388.88,90.39c1.43,0,2.37-.27,2.81-.8.45-.63.67-1.43.67-2.41V26.34c0-.98-.27-1.74-.8-2.28-.45-.63-1.43-.94-2.95-.94v-1.61h22.65v1.61c-2.06,0-3.08.58-3.08,1.74,0,.54.18,1.03.54,1.47l21.84,42.88,22.65-42.88c.09-.27.18-.54.27-.8.18-.27.27-.54.27-.8,0-.45-.27-.8-.8-1.07-.45-.36-1.29-.54-2.55-.54v-1.61h23.99v1.61c-1.52,0-2.55.31-3.08.94-.45.54-.67,1.3-.67,2.28v60.84c0,.98.22,1.79.67,2.41.54.54,1.56.8,3.08.8v1.61h-18.76v-1.61c1.52,0,2.5-.27,2.95-.8.54-.63.8-1.43.8-2.41v-52.93l-.4-.27-28.54,56.68-28.54-56.68-.13.27v52.93c-.09.98.09,1.79.54,2.41.45.54,1.29.8,2.55.8v1.61h-15.95v-1.61Z","x":388.6},"H":{"d":"M574.47,87.18c0,.98.22,1.79.67,2.41.45.54,1.3.8,2.55.8v1.61h-17.69v-1.61c1.25,0,2.1-.27,2.55-.8.45-.63.67-1.43.67-2.41v-26.8h-47.44v26.8c0,.98.22,1.79.67,2.41.45.54,1.29.8,2.55.8v1.61h-17.69v-1.61c1.25,0,2.1-.27,2.55-.8.45-.63.67-1.43.67-2.41V26.34c0-.98-.22-1.74-.67-2.28-.45-.63-1.3-.94-2.55-.94v-1.61h17.69v1.61c-1.25,0-2.1.31-2.55.94-.45.54-.67,1.3-.67,2.28v25.19h47.44v-25.19c0-.98-.22-1.74-.67-2.28-.45-.63-1.3-.94-2.55-.94v-1.61h17.69v1.61c-1.25,0-2.1.31-2.55.94-.45.54-.67,1.3-.67,2.28v60.84Z","x":501.3},"A2":{"d":"M649.69,64.4l-15.14-31.62-13.94,31.62h29.08ZM611.76,83.96c-.36.8-.76,1.7-1.21,2.68-.45.98-.67,1.74-.67,2.28,0,.98.76,1.47,2.28,1.47v1.61h-16.48v-1.61c.54,0,.98-.04,1.34-.13.45-.09.85-.36,1.21-.8s.76-1.07,1.21-1.88c.45-.89,1.03-2.05,1.74-3.48l24.25-54.14c.71-1.52,1.25-2.64,1.61-3.35.36-.8.54-1.43.54-1.88,0-1.07-.8-1.61-2.41-1.61v-1.61h19.56v1.61c-1.43,0-2.14.54-2.14,1.61,0,.54.22,1.25.67,2.14.45.8,1.03,1.97,1.74,3.48l25.73,53.33c.8,1.61,1.43,2.86,1.88,3.75.45.89.85,1.56,1.21,2.01.45.45.89.71,1.34.8.45.09,1.07.13,1.88.13v1.61h-18.63v-1.61c1.07,0,1.79-.13,2.14-.4.36-.36.54-.85.54-1.47,0-.45-.13-.89-.4-1.34-.18-.54-.62-1.61-1.34-3.22l-5.09-10.72h-37.92l-4.56,10.72Z","x":595.7}},"SUB":"M203.559 135V118.2H214.791V119.304H204.783V135H203.559ZM204.639 127.584V126.48H213.735V127.584H204.639ZM227.537 135.12C226.289 135.12 225.129 134.912 224.057 134.496C223.001 134.064 222.073 133.464 221.273 132.696C220.489 131.912 219.881 131.008 219.449 129.984C219.017 128.944 218.801 127.816 218.801 126.6C218.801 125.384 219.017 124.264 219.449 123.24C219.881 122.2 220.489 121.296 221.273 120.528C222.073 119.744 223.001 119.144 224.057 118.728C225.129 118.296 226.289 118.08 227.537 118.08C228.785 118.08 229.937 118.296 230.993 118.728C232.065 119.144 232.993 119.736 233.777 120.504C234.561 121.272 235.169 122.176 235.601 123.216C236.049 124.24 236.273 125.368 236.273 126.6C236.273 127.832 236.049 128.968 235.601 130.008C235.169 131.032 234.561 131.928 233.777 132.696C232.993 133.464 232.065 134.064 230.993 134.496C229.937 134.912 228.785 135.12 227.537 135.12ZM227.537 133.992C228.609 133.992 229.601 133.808 230.513 133.44C231.425 133.072 232.217 132.552 232.889 131.88C233.561 131.208 234.081 130.424 234.449 129.528C234.833 128.632 235.025 127.656 235.025 126.6C235.025 125.528 234.833 124.552 234.449 123.672C234.081 122.776 233.561 121.992 232.889 121.32C232.217 120.648 231.425 120.128 230.513 119.76C229.601 119.392 228.609 119.208 227.537 119.208C226.465 119.208 225.473 119.392 224.561 119.76C223.649 120.128 222.849 120.648 222.161 121.32C221.489 121.992 220.961 122.776 220.577 123.672C220.209 124.552 220.025 125.528 220.025 126.6C220.025 127.656 220.209 128.632 220.577 129.528C220.961 130.424 221.489 131.208 222.161 131.88C222.849 132.552 223.649 133.072 224.561 133.44C225.473 133.808 226.465 133.992 227.537 133.992ZM242.438 135V118.2H248.462C250.574 118.2 252.23 118.696 253.43 119.688C254.63 120.68 255.23 122.072 255.23 123.864C255.23 125.032 254.958 126.04 254.414 126.888C253.87 127.72 253.094 128.368 252.086 128.832C251.078 129.28 249.87 129.504 248.462 129.504H243.11L243.662 128.928V135H242.438ZM254.102 135L249.734 128.904H251.126L255.494 135H254.102ZM243.662 129L243.11 128.424H248.462C250.27 128.424 251.638 128.024 252.566 127.224C253.51 126.424 253.982 125.304 253.982 123.864C253.982 122.408 253.51 121.288 252.566 120.504C251.638 119.704 250.27 119.304 248.462 119.304H243.11L243.662 118.704V129ZM261.632 135V118.2H262.664L270.464 131.664H269.912L277.688 118.2H278.696L278.72 135H277.52L277.496 120.048H277.832L270.464 132.768H269.864L262.472 120.048H262.832V135H261.632ZM286.497 135V118.2H297.729V119.304H287.721V133.896H298.089V135H286.497ZM287.577 127.008V125.928H296.673V127.008H287.577ZM304.472 135V118.2H310.496C312.608 118.2 314.264 118.696 315.464 119.688C316.664 120.68 317.264 122.072 317.264 123.864C317.264 125.032 316.992 126.04 316.448 126.888C315.904 127.72 315.128 128.368 314.12 128.832C313.112 129.28 311.904 129.504 310.496 129.504H305.144L305.696 128.928V135H304.472ZM316.136 135L311.768 128.904H313.16L317.528 135H316.136ZM305.696 129L305.144 128.424H310.496C312.304 128.424 313.672 128.024 314.6 127.224C315.544 126.424 316.016 125.304 316.016 123.864C316.016 122.408 315.544 121.288 314.6 120.504C313.672 119.704 312.304 119.304 310.496 119.304H305.144L305.696 118.704V129ZM323.665 135V118.2H324.889V133.896H334.561V135H323.665ZM341.803 135V128.904L342.091 129.696L335.035 118.2H336.379L342.787 128.64H342.115L348.523 118.2H349.795L342.739 129.696L343.027 128.904V135H341.803ZM362.847 135V118.2H369.495C371.271 118.2 372.831 118.56 374.175 119.28C375.519 120 376.559 120.992 377.295 122.256C378.047 123.52 378.423 124.968 378.423 126.6C378.423 128.232 378.047 129.68 377.295 130.944C376.559 132.208 375.519 133.2 374.175 133.92C372.831 134.64 371.271 135 369.495 135H362.847ZM364.071 133.896H369.399C370.983 133.896 372.359 133.584 373.527 132.96C374.695 132.336 375.599 131.48 376.239 130.392C376.879 129.288 377.199 128.024 377.199 126.6C377.199 125.176 376.879 123.92 376.239 122.832C375.599 121.728 374.695 120.864 373.527 120.24C372.359 119.616 370.983 119.304 369.399 119.304H364.071V133.896ZM397.051 135V118.2H398.275V135H397.051ZM384.595 135V118.2H385.819V135H384.595ZM385.675 127.008V125.928H397.195V127.008H385.675ZM403.254 135L410.982 118.2H412.206L419.934 135H418.614L411.318 118.968H411.846L404.574 135H403.254ZM406.086 130.272L406.494 129.24H416.55L416.958 130.272H406.086ZM424.904 135V118.2H430.928C433.04 118.2 434.696 118.696 435.896 119.688C437.096 120.68 437.696 122.072 437.696 123.864C437.696 125.032 437.424 126.04 436.88 126.888C436.336 127.72 435.56 128.368 434.552 128.832C433.544 129.28 432.336 129.504 430.928 129.504H425.576L426.128 128.928V135H424.904ZM436.568 135L432.2 128.904H433.592L437.96 135H436.568ZM426.128 129L425.576 128.424H430.928C432.736 128.424 434.104 128.024 435.032 127.224C435.976 126.424 436.448 125.304 436.448 123.864C436.448 122.408 435.976 121.288 435.032 120.504C434.104 119.704 432.736 119.304 430.928 119.304H425.576L426.128 118.704V129ZM444.097 135V118.2H445.129L452.929 131.664H452.377L460.153 118.2H461.161L461.185 135H459.985L459.961 120.048H460.297L452.929 132.768H452.329L444.937 120.048H445.297V135H444.097ZM466.155 135L473.883 118.2H475.107L482.835 135H481.515L474.219 118.968H474.747L467.475 135H466.155ZM468.987 130.272L469.395 129.24H479.451L479.859 130.272H468.987ZM495.888 135V118.2H502.896C504.704 118.2 506.12 118.568 507.144 119.304C508.168 120.04 508.68 121.104 508.68 122.496C508.68 123.408 508.464 124.176 508.032 124.8C507.6 125.424 507 125.896 506.232 126.216C505.48 126.52 504.632 126.672 503.688 126.672L504.12 126.192C505.272 126.192 506.256 126.36 507.072 126.696C507.888 127.032 508.504 127.52 508.92 128.16C509.352 128.8 509.568 129.6 509.568 130.56C509.568 131.968 509.056 133.064 508.032 133.848C507.008 134.616 505.456 135 503.376 135H495.888ZM497.112 133.944H503.376C504.992 133.944 506.224 133.672 507.072 133.128C507.92 132.568 508.344 131.68 508.344 130.464C508.344 129.264 507.92 128.392 507.072 127.848C506.224 127.288 504.992 127.008 503.376 127.008H496.968V125.952H502.848C504.304 125.952 505.432 125.672 506.232 125.112C507.032 124.552 507.432 123.712 507.432 122.592C507.432 121.488 507.032 120.656 506.232 120.096C505.432 119.536 504.304 119.256 502.848 119.256H497.112V133.944ZM522.431 135.12C520.351 135.12 518.711 134.512 517.511 133.296C516.311 132.08 515.711 130.272 515.711 127.872V118.2H516.935V127.824C516.935 129.92 517.415 131.472 518.375 132.48C519.335 133.488 520.695 133.992 522.455 133.992C524.199 133.992 525.551 133.488 526.511 132.48C527.471 131.472 527.951 129.92 527.951 127.824V118.2H529.175V127.872C529.175 130.272 528.575 132.08 527.375 133.296C526.175 134.512 524.527 135.12 522.431 135.12ZM536.807 135V118.2H537.839L545.639 131.664H545.087L552.863 118.2H553.871L553.895 135H552.695L552.671 120.048H553.007L545.639 132.768H545.039L537.647 120.048H538.007V135H536.807ZM566.088 135.12C564.84 135.12 563.656 134.912 562.536 134.496C561.432 134.064 560.576 133.512 559.968 132.84L560.52 131.928C561.096 132.52 561.88 133.024 562.872 133.44C563.88 133.84 564.944 134.04 566.064 134.04C567.184 134.04 568.096 133.896 568.8 133.608C569.52 133.304 570.048 132.904 570.384 132.408C570.736 131.912 570.912 131.36 570.912 130.752C570.912 130.032 570.72 129.456 570.336 129.024C569.952 128.592 569.448 128.248 568.824 127.992C568.2 127.736 567.52 127.52 566.784 127.344C566.048 127.168 565.304 126.984 564.552 126.792C563.8 126.584 563.112 126.32 562.488 126C561.864 125.68 561.36 125.248 560.976 124.704C560.608 124.144 560.424 123.424 560.424 122.544C560.424 121.744 560.632 121.008 561.048 120.336C561.464 119.664 562.112 119.12 562.992 118.704C563.872 118.288 565 118.08 566.376 118.08C567.304 118.08 568.216 118.216 569.112 118.488C570.024 118.76 570.8 119.128 571.44 119.592L570.984 120.576C570.28 120.096 569.52 119.744 568.704 119.52C567.904 119.28 567.128 119.16 566.376 119.16C565.304 119.16 564.416 119.312 563.712 119.616C563.008 119.92 562.488 120.328 562.152 120.84C561.816 121.336 561.648 121.896 561.648 122.52C561.648 123.24 561.832 123.816 562.2 124.248C562.584 124.68 563.088 125.024 563.712 125.28C564.336 125.536 565.024 125.752 565.776 125.928C566.528 126.104 567.272 126.296 568.008 126.504C568.744 126.696 569.424 126.952 570.048 127.272C570.672 127.592 571.176 128.024 571.56 128.568C571.944 129.112 572.136 129.816 572.136 130.68C572.136 131.464 571.92 132.2 571.488 132.888C571.056 133.56 570.392 134.104 569.496 134.52C568.616 134.92 567.48 135.12 566.088 135.12Z"};

  // Authored scene sheet (durations): Original 2.0 | BumsOut 1.5 | HOut 1.1 |
  // Close 1.5 | HIn 1.3 | FontShift 2.0 | Tagline 2.2 | Hold 2.0. Cues are the
  // running sums. The Hold tail is dropped: the final frame IS the static logo.
  var CUES = { BumsOut: 2.0, HOut: 3.5, Close: 4.6, HIn: 6.1, FontShift: 7.4, Tagline: 9.4 };
  var DURATION = 10.6; // last motion (tagline fade) settles at 10.55
  // The composition was authored for an already-visible stage; in the header
  // the slot starts blank (the inline gate holds the static logo), so the
  // opening wordmark fades in. Eats into the 2s Original hold — cues unmoved.
  var INTRO_FADE = 0.6;

  var OS = 1.4214;              // old-logo units -> site-logo units
  var ODY = 92 - 60.6 * OS;     // baseline alignment for old glyphs
  var G0 = -25.5, G1 = 107.5;   // group offset: full wordmark -> centred DARMHA
  var INK = '#000000';
  var CLOSED = { D: 43.6, A1: 95.0, R: 147.8, M: 198.0, H: 255.7, A2: 301.9 };
  var NEWABS = { D: 104.2, A1: 193.7, R: 293.0, M: 388.6, H: 501.3, A2: 595.7 };
  var OPEN_X = { A1: 141.2, R: 194.0, M: 244.2 };
  var KEYS = ['D', 'A1', 'R', 'M', 'H', 'A2'];
  var OLD_KEY = { D: 'D', A1: 'A1', R: 'R', M: 'M1', H: 'H', A2: 'A2' };
  var BUMS = ['B', 'U', 'M2', 'S'];
  var STORAGE_KEY = 'darmha:logo-plays';        // mirrored by the inline gate in sections/header.liquid
  var PENDING_CLASS = 'darmha-anim-pending';    // set by that inline gate before the logo <img> parses
  var HIDDEN = 0.001;           // below this a glyph is not rendered

  // ---- easings (dc-runtime semantics: progress clamped to [0,1]) ---------
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }
  function easeInOutSine(t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  }
  function animate(from, to, start, dur, ease) {
    return function (T) {
      var p = (T - start) / dur;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      return from + (to - from) * ease(p);
    };
  }
  function glide(from, to, start, dur) { return animate(from, to, start, dur, easeInOutCubic); }
  function settle(from, to, start, dur) { return animate(from, to, start, dur, easeInOutQuart); }
  function fade(from, to, start, dur) { return animate(from, to, start, dur, easeInOutSine); }

  // ---- pure frame model --------------------------------------------------
  // pieces() and frame(T) are parallel arrays in a fixed order:
  // [old D, new D, old A1, new A1, ... old A2, new A2] (12), the departing
  // old-position H (1), B U M2 S (4), tagline (1) — 18 pieces total.
  function pieces() {
    var list = [];
    for (var i = 0; i < KEYS.length; i++) {
      list.push({ d: LETTERS.OLD[OLD_KEY[KEYS[i]]].d });
      list.push({ d: LETTERS.NEW[KEYS[i]].d });
    }
    list.push({ d: LETTERS.OLD.H.d });
    for (var b = 0; b < BUMS.length; b++) list.push({ d: LETTERS.OLD[BUMS[b]].d });
    list.push({ d: LETTERS.SUB });
    return list;
  }

  function oldTransform(x, minX) {
    return 'translate(' + (x - minX * OS) + ' ' + ODY + ') scale(' + OS + ')';
  }
  function newTransform(x, minX) {
    return 'translate(' + (x - minX) + ' 0)';
  }

  function frame(T) {
    var intro = fade(0, 1, 0, INTRO_FADE)(T);
    var G = glide(G0, G1, CUES.Close, 1.1)(T);
    var hOutOp = fade(1, 0, CUES.HOut, 0.7)(T);
    var hInOp = fade(0, 1, CUES.HIn, 0.85)(T);
    var fs = CUES.FontShift;
    var oldOp = fade(1, 0, fs + 0.05, 0.7)(T);
    var newOp = fade(0, 1, fs + 0.45, 0.85)(T);
    var p = settle(0, 1, fs, 1.5)(T);

    var closeX = {
      D: CLOSED.D,
      A1: glide(OPEN_X.A1, CLOSED.A1, CUES.Close, 1.1)(T),
      R: glide(OPEN_X.R, CLOSED.R, CUES.Close, 1.1)(T),
      M: glide(OPEN_X.M, CLOSED.M, CUES.Close, 1.1)(T),
      H: CLOSED.H,
      A2: CLOSED.A2
    };

    var out = [];
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i];
      var from = closeX[k] * OS + G;
      var x = from + (NEWABS[k] - from) * p;
      var oldGlyph = LETTERS.OLD[OLD_KEY[k]];
      out.push({
        transform: oldTransform(x, oldGlyph.x),
        opacity: (k === 'H' ? hInOp : 1) * oldOp * intro
      });
      out.push({
        transform: newTransform(x, LETTERS.NEW[k].x),
        opacity: newOp * intro
      });
    }
    var hx = 95.0 * OS + G;
    out.push({ transform: oldTransform(hx, LETTERS.OLD.H.x), opacity: hOutOp * intro });
    for (var b = 0; b < BUMS.length; b++) {
      var bx = LETTERS.OLD[BUMS[b]].x * OS + G;
      out.push({
        transform: oldTransform(bx, LETTERS.OLD[BUMS[b]].x),
        opacity: fade(1, 0, CUES.BumsOut + (3 - b) * 0.16, 0.7)(T) * intro
      });
    }
    // intro multiplies every piece uniformly: it is 1 from INTRO_FADE onward,
    // so only the opening is affected and no later cue needs special-casing.
    out.push({ transform: '', opacity: fade(0, 1, CUES.Tagline + 0.15, 1.0)(T) * intro });
    return out;
  }

  // ---- factory -----------------------------------------------------------
  function create(deps) {
    var win = deps.win;
    var doc = deps.doc;
    var now = deps.now;
    var raf = deps.raf;
    var caf = deps.caf;
    var playedThisLoad = false;

    // The inline gate holds the static logo invisible (CSS, with a 2s
    // self-healing reveal) when it predicts a play. Whatever this module
    // decides, the mark must come off: after the img is hidden when playing,
    // immediately when declining.
    function clearPending() {
      try {
        var root = doc.documentElement;
        if (root && root.classList) root.classList.remove(PENDING_CLASS);
      } catch (err) { /* CSS fallback reveals the static logo */ }
    }

    function readCount() {
      try {
        var n = parseInt(win.sessionStorage.getItem(STORAGE_KEY), 10);
        return isNaN(n) ? 0 : n;
      } catch (err) {
        return Infinity; // storage unavailable: never play, never write
      }
    }

    // Returns whether the increment was persisted. A play that cannot be
    // counted must not start — otherwise a blocked setItem replays the
    // animation on every load, uncapped (audit 002 blocker 2).
    function recordPlay() {
      try {
        win.sessionStorage.setItem(STORAGE_KEY, String(readCount() + 1));
        return true;
      } catch (err) {
        return false;
      }
    }

    function shouldPlay(cap) {
      if (!(cap > 0)) return false;
      if (playedThisLoad) return false;
      if (win.Shopify && win.Shopify.designMode) return false;
      try {
        if (typeof win.matchMedia === 'function' &&
            win.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      } catch (err) {
        return false;
      }
      var conn = win.navigator && win.navigator.connection;
      if (conn && conn.saveData === true) return false;
      if (doc.visibilityState === 'hidden') return false;
      return readCount() < cap;
    }

    function applyFrame(nodes, attrs) {
      for (var i = 0; i < nodes.length; i++) {
        if (attrs[i].opacity <= HIDDEN) {
          nodes[i].setAttribute('visibility', 'hidden');
        } else {
          nodes[i].removeAttribute('visibility');
          nodes[i].setAttribute('opacity', attrs[i].opacity);
          if (attrs[i].transform) nodes[i].setAttribute('transform', attrs[i].transform);
        }
      }
    }

    // Transactional (audit 002 blocker 1): the pure, fallible work — measure,
    // build, first frame — happens before any DOM mutation or count write; the
    // mutation phase rolls back completely on any failure; the session count
    // commits last, so it changes if and only if an animation actually starts.
    // All of this runs in one task, so no partial state is ever painted.
    function play(anchor, img) {
      var ns = 'http://www.w3.org/2000/svg';
      var svg, nodes, previousPosition;
      try {
        var anchorBox = anchor.getBoundingClientRect();
        var imgBox = img.getBoundingClientRect();
        if (imgBox.width < 4 || imgBox.height < 4) return false;

        svg = doc.createElementNS(ns, 'svg');
        svg.setAttribute('viewBox', '0 0 775 144');
        svg.setAttribute('aria-hidden', 'true');
        svg.style.position = 'absolute';
        svg.style.left = (imgBox.left - anchorBox.left) + 'px';
        svg.style.top = (imgBox.top - anchorBox.top) + 'px';
        svg.style.width = imgBox.width + 'px';
        svg.style.height = imgBox.height + 'px';
        svg.style.pointerEvents = 'none'; // clicks fall through to the home link
        var geometry = pieces();
        nodes = [];
        for (var i = 0; i < geometry.length; i++) {
          var path = doc.createElementNS(ns, 'path');
          path.setAttribute('d', geometry[i].d);
          path.setAttribute('fill', INK);
          svg.appendChild(path);
          nodes.push(path);
        }
        applyFrame(nodes, frame(0)); // still detached: nothing to roll back
        previousPosition = anchor.style.position || '';
      } catch (err) {
        return false; // nothing was mutated
      }

      var start = 0;
      var frameId = null;
      var done = false;
      var listenerInstalled = false;
      // Cleanup and rollback are the same routine. Every step is independent
      // and non-throwing: a failing cancel or listener removal must never
      // prevent the static logo from being restored (audit 002 blocker 1).
      function finish() {
        if (done) return;
        done = true;
        try { if (frameId !== null) caf(frameId); } catch (err) { /* keep going */ }
        frameId = null;
        if (listenerInstalled) {
          try { win.removeEventListener('resize', finish); } catch (err) { /* keep going */ }
          listenerInstalled = false;
        }
        try { img.style.visibility = ''; } catch (err) { /* keep going */ }
        try { if (svg.parentNode) svg.parentNode.removeChild(svg); } catch (err) { /* keep going */ }
        try { anchor.style.position = previousPosition; } catch (err) { /* keep going */ }
      }
      function tick() {
        if (done) return;
        frameId = null;
        try {
          var T = (now() - start) / 1000;
          if (T >= DURATION) { finish(); return; }
          applyFrame(nodes, frame(T));
          frameId = raf(tick);
        } catch (err) {
          finish();
        }
      }

      try {
        anchor.style.position = 'relative';
        anchor.appendChild(svg);
        img.style.visibility = 'hidden';
        // The overlay is pinned to a measured box; any reflow invalidates the
        // measurement, so a resize settles straight to the static logo.
        win.addEventListener('resize', finish);
        listenerInstalled = true;
        start = now();
        frameId = raf(tick);
        if (!recordPlay()) {
          finish(); // uncountable play: full rollback before anything paints
          return false;
        }
      } catch (err) {
        finish();
        return false;
      }
      playedThisLoad = true;
      clearPending(); // img was hidden above in this same task; the CSS hold may go
      return true;
    }

    function bootInner() {
      var anchor = doc.querySelector('.logo__link[data-darmha-anim-plays]');
      if (!anchor) return false;
      var img = anchor.querySelector('img.logo__image');
      if (!img) return false;
      // Transparent-header mode swaps in a different logo colourway; the
      // animation is authored in the standard ink, so sit that mode out.
      if (anchor.querySelector('.logo__image-transparent')) return false;
      var cap = parseInt(anchor.getAttribute('data-darmha-anim-plays'), 10);
      if (!shouldPlay(cap)) return false;
      return play(anchor, img) === true;
    }

    function boot() {
      var playing = false;
      try {
        playing = bootInner();
      } catch (err) {
        playing = false; // every failure leaves the static logo untouched
      }
      // Declined for any reason: release the CSS hold so the static logo
      // shows immediately instead of waiting out the 2s fallback reveal.
      if (!playing) clearPending();
      return playing;
    }

    return {
      boot: boot,
      play: play,
      shouldPlay: shouldPlay,
      readCount: readCount,
      recordPlay: recordPlay,
      _internals: {
        frame: frame,
        pieces: pieces,
        CUES: CUES,
        DURATION: DURATION,
        INTRO_FADE: INTRO_FADE,
        NEWABS: NEWABS,
        STORAGE_KEY: STORAGE_KEY
      }
    };
  }

  window.DarmhaLogoAnim = window.DarmhaLogoAnim || {};
  window.DarmhaLogoAnim.create = create;

  // ---- boot with real dependencies --------------------------------------
  if (typeof document !== 'undefined' && document.addEventListener) {
    try {
      var instance = create({
        win: window,
        doc: document,
        now: function () { return Date.now(); },
        raf: function (fn) { return window.requestAnimationFrame(fn); },
        caf: function (id) { window.cancelAnimationFrame(id); }
      });
      window.DarmhaLogoAnim.instance = instance;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { instance.boot(); });
      } else {
        instance.boot();
      }
    } catch (err) { /* fail static */ }
  }
})();
